// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3UnLV","amount":"Amount_amount__yzN7E","tip":"Amount_tip__2fC70","tipHeader":"Amount_tipHeader__1sT9E","tipsWrap":"Amount_tipsWrap__2uX9P"};